// @ts-nocheck 9d032c1b
import addPanelDataConsts from '#packages/addPanelDataConsts';
import * as wixStoreEditorActionsService from '../../wixStoreEditorActionsService';
import * as utils from '@wix/santa-editor-utils';

export default {
  type: addPanelDataConsts.SECTIONS_TYPES.PRESET,
  id: 'wixStoresProductGridWidget',
  hide: false,
  title: 'add_preset_Store_Galleries_2',
  subNavigationTitle: 'add_preset_Store_Galleries_2',
  presetTitle: 'add_preset_Store_Galleries_2',
  tooltipTitle: 'add_preset_Store_Galleries_2',
  sectionName: 'productGridWidget',
  subNavigationHide: false,
  showSectionHeader: true,
  additionalBehaviours: {
    labelMode: addPanelDataConsts.LABEL_BEHAVIOUR.ALWAYS,
    infoIcon: addPanelDataConsts.INFO_ICON_BEHAVIOUR.NONE,
    hoverImageAction: addPanelDataConsts.HOVER_IMAGE_ACTIONS.NONE,
    scaleProportion: addPanelDataConsts.DEFAULT_SCALE_FOR_PRESET,
    iconEnabledForComps: [],
  },
  props: {
    image: utils.isOnWixStudio()
      ? 'wixStore/sections/studio/gridGallery.png'
      : 'wixStore/sections/productGridGalleryRevamp.png',
    imageHover: null,
    onDrop: wixStoreEditorActionsService.onWidgetDrop(),
    onClick: wixStoreEditorActionsService.onWidgetClick(),
    items: [
      {
        id: 'Wix_Stores_Grid_Gallery',
        structure: {
          skin: 'wysiwyg.viewer.skins.TPAWidgetSkin',
          layout: {
            width: 980,
            height: 965,
            scale: 1,
            rotationInDegrees: 0,
            fixedPosition: false,
          },
          componentType: 'wysiwyg.viewer.components.tpapps.TPAWidget',
          data: {
            type: 'TPAWidget',
            metaData: { isPreset: true, schemaVersion: '1.0', isHidden: false },
            applicationId: '15',
            widgetId: '13afb094-84f9-739f-44fd-78d036adb028',
          },
          style: {
            type: 'TopLevelStyle',
            id: 'tpaw0',
            metaData: {
              isPreset: false,
              schemaVersion: '1.0',
              isHidden: false,
            },
            style: { groups: {}, properties: {}, propertiesSource: {} },
            componentClassName: '',
            pageId: '',
            compId: '',
            styleType: 'system',
            skin: 'wysiwyg.viewer.skins.TPAWidgetSkin',
          },
          id: 'i6ky51v8',
        },
        preset: {
          rect: { width: 324, height: 230, x: 0, y: 0 },
          label: '',
          tags: null,
          video: {
            poster: 'poster-white-1x1.png',
            source: 'store-video-thumb-grid',
          },
        },
      },
    ],
    compTypes: ['wysiwyg.viewer.components.tpapps.TPAWidget'],
  },
};
